export const TECHNOLOGY = "TECHNOLOGY"
export const DATE_FORMAT = "DATE_FORMAT"
export const STRING_FORMAT = "STRING_FORMAT"